import { render, staticRenderFns } from "./GeneralDisplayBox.vue?vue&type=template&id=50ac789b&scoped=true&"
import script from "./GeneralDisplayBox.vue?vue&type=script&lang=js&"
export * from "./GeneralDisplayBox.vue?vue&type=script&lang=js&"
import style0 from "./GeneralDisplayBox.vue?vue&type=style&index=0&id=50ac789b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ac789b",
  null
  
)

export default component.exports